import { put, call, takeLatest } from 'redux-saga/effects';

import * as actionCreators from '../redux/actions';
import * as actionTypes from '../redux/actions/type';
import API, { ROUTES } from "../../../commons/api/api";

function* getAwards({params}) {
  try {
    const response = yield call(() =>
      API.get(ROUTES.API_AWARD, {params})
    );
    yield put(actionCreators.getAwardsSuccess(response.data.data));
    
    if (response.ok) {
      const { data } = response;
     
    }
  } catch (error) {
    
  }
}

function* awards() {
  yield takeLatest(actionTypes.GET_AWARDS, getAwards);
}

export default awards;
